import { render, staticRenderFns } from "./SalePage20230001Step2.vue?vue&type=template&id=08b35252&scoped=true"
import script from "./SalePage20230001Step2.vue?vue&type=script&lang=js"
export * from "./SalePage20230001Step2.vue?vue&type=script&lang=js"
import style0 from "./SalePage20230001Step2.vue?vue&type=style&index=0&id=08b35252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b35252",
  null
  
)

export default component.exports